export const AUTH_DO_LOGIN            = 'AUTH_DO_LOGIN';
export const AUTH_DO_LOGOUT           = 'AUTH_DO_LOGOUT';


